import { useDeferredValue } from 'react';
import { type GlobalFeatureName, isGlobalFeatureEnabled } from 'owa-feature-flags';

export function useDeferredValueFlighted<T>(value: T, feature: GlobalFeatureName): T {
    if (isGlobalFeatureEnabled(feature)) {
        /* eslint-disable-next-line owa-custom-rules/no-conditional-react-hooks, react-hooks/rules-of-hooks -- (https://aka.ms/OWALintWiki)
         * Yes, this technically breaks the rules of hooks; but because we guarantee that feature flags are static
         * across a session, the hook will either always get called or never get called */
        return useDeferredValue(value);
    } else {
        return value;
    }
}
